import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RealEstateComponent } from './real-estate/real-estate.component';
import { SoftwareServiceComponent } from './software-service/software-service.component';
import { HealthCareServiceComponent } from './health-care-service/health-care-service.component';
import { DesignServicesComponent } from './design-services/design-services.component';
import { DigitalMarketingComponent } from './digital-marketing/digital-marketing.component';
import { WritingAndEditingComponent } from './writing-and-editing/writing-and-editing.component';
import { MediaProductionComponent } from './media-production/media-production.component';
import { MusicAudioVoiceComponent } from './music-audio-voice/music-audio-voice.component';
import { ConsultingAndProfessionalComponent } from './consulting-and-professional/consulting-and-professional.component';
import { LegalAndCompianceServicesComponent } from './legal-and-compiance-services/legal-and-compiance-services.component';
import { LogisticsSupplyChainComponent } from './logistics-supply-chain/logistics-supply-chain.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { EnvironmentalServicesComponent } from './environmental-services/environmental-services.component';
import { ReasearchAndAnalysisComponent } from './reasearch-and-analysis/reasearch-and-analysis.component';
import { EventServicesComponent } from './event-services/event-services.component';
import { TrainingAndEducationalServicesComponent } from './training-and-educational-services/training-and-educational-services.component';


const routes: Routes = [
    {path:'Civil-Architecture-and-Planning',component:RealEstateComponent},
    {path:'Software-and-IT-Services',component:SoftwareServiceComponent},
    {path:'Healthcare-Services',component:HealthCareServiceComponent},
    {path:'Design',component:DesignServicesComponent},
    {path:'Digital-Marketing',component:DigitalMarketingComponent},
    {path:'Writing-&-Editing',component:WritingAndEditingComponent},
    {path:'Media-Production',component:MediaProductionComponent},
    {path:'Music,-Audio-and-Voice',component:MusicAudioVoiceComponent},
    {path:'Consulting-&-Professional-Services',component:ConsultingAndProfessionalComponent},
    {path:'Legal-and-Compliance-Services',component:LegalAndCompianceServicesComponent},
    {path:'Logistics-&-Supply-Chain', component: LogisticsSupplyChainComponent},
    {path: 'Insurance', component: InsuranceComponent},
    {path:'Environmental-Services', component: EnvironmentalServicesComponent},
    {path: 'Research-and-Analysis', component: ReasearchAndAnalysisComponent},
    {path: 'Events-Services', component: EventServicesComponent},
    {path: 'Training-and-Educational-Services', component: TrainingAndEducationalServicesComponent},
];  

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IndustriesRouting { } 